<template>
    <div>
        <b-modal id="editUserModel" centered ref="editUserModel" size="xl" no-close-on-esc
            no-close-on-backdrop lazy unmount-lazy>
            <template #modal-header>
                <h5 class="modal-title">Edit User</h5>
            </template>
            <template #default>
                <div class="editUserContent">
                    <BasicInformation :userDetail="editingUserDetails.userDetail" :isEnable="isEnabled"
                        @UserStatusChanged="UserStatusChanged" :canDisable="editingUserDetails.canDisable"
                        :userAccounts="userAccounts" ref="bacisInfo"></BasicInformation>
                    <b-tabs content-class="mt-2" v-model="tabIndex" fill>
                        <b-tab title="User Information" @click="ChangedTab(0)">
                            <span class="errorMessage" v-if="v$.form.$error">Required fields cannot be blank.</span>
                            <span class="errorMessage" v-if="isUserCreationFailed && !v$.form.$error">User Creation
                                failed.</span>
                            <UserForm ref="userForm" :startTabIndex="4" :userDetails="form" :isConfirmUser="true"
                                @onFormDirty="formIsDirty" @onUserFormValue="setUserDetails" :isOpenInEditFlow="true">
                            </UserForm>
                        </b-tab>
                        <b-tab title="Account and Application Access" @click="ChangedTab(1)">
                            <span>Select an account to manage accessible applications and permissions. To remove the user
                                from an account, select 'Remove' next to the account name.</span>

                            <Accounts v-if="userDetail.sfContactId != ''" ref="accessibleAccounts"
                                name="confirmaccessibleAccounts"
                                :editingUserAssociatedAccounts="editingUserDetails.accountsApplicationsAndRolesDetail"
                                :allAccounts="editingUserDetails.userAccounts" :sfContactID="userDetail.sfContactId"
                                :srcAccount="srcAccount" :userDetail="userDetail" @setEnableStatus="setEnableStatus"
                                @setAssociatedAccount="setUserAccounts"></Accounts>
                            <AccessibleApplications
                                v-if="userDetail.sfContactId != '' && Object.keys(account).length > 0 && userAccounts.length > 0"
                                ref="accessibleApplications" name="confirmaccessibleApplications" :username="user_name"
                                :sfContactID="userDetail.sfContactId" :adfsGuid="userDetail.adfsGuid"
                                :accessibleApplicationAccount="account" :isEditPermission="true" :isUserEnable="isEnabled"
                                @UserCommunityAccessChanged="UserCommunityAccessChanged"
                                :isCustomerComunityEnabled="isCustomerComunityEnabled"
                                :isPartnerCommunity="isPartnerCommunity"></AccessibleApplications>
                            <ContactRole v-if="Object.keys(account).length > 0 && userAccounts.length > 0"
                                :role="account.roles" :applicationName="applicationName" :accessibleAccount="account">
                            </ContactRole>
                        </b-tab>
                        <b-tab title="Audit History" @click="ChangedTab(2)">
                            <AuditHistory :editingUserauditHistory="editingUserDetails.auditHistory"
                                :userName="editingUserDetails.userDetail.userName"></AuditHistory>
                        </b-tab>
                    </b-tabs>
                </div>
            </template>
            <template v-slot:modal-footer="{ ok, cancel, hide }" class="modal-footer">
                <!-- <b-button class="adduserbtn" v-b-modal.CancelPromptModal>Close</b-button> -->
                <b-button class="um-btn" @click="cancelChanges" tabindex="17">Close</b-button>
                <b-button class="um-btn" @click="SaveUser" :disabled="!userDetail.enabled || $store.getters.isImpersonation"
                    tabindex="16">Save</b-button>
            </template>
        </b-modal>
        <ErrorMessage ref="errorMessageRef" :errorMessage="error" callbackOnClose></ErrorMessage>
        <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
        <ApplicationSetting v-if="Object.keys(account).length > 0" :userDetail="form"
            :accessibleApplications="accessibleApplicationList" :isEditUser="true"
            :accessibleApplicationAccount="account" :applicationSettingTitle="applicationSettingTitle"
            :sfAccountId="account.sfAccountID" :accountContactRoles="accountContactRoleList"
            :userApplicationPermissions="allPermissions" :isAccountPermissionAccess="isAccountPermissionAccess"
            :sfAccountNumber="account.cadebillAccountNo" :isCustomerComunityEnabled="isCustomerComunityEnabled"
            :isPartnerCommunity="isPartnerCommunity" :showPermissions="showPermissions"></ApplicationSetting>

        <div>
            <b-modal id="CancelPromptModal" ref="CancelPromptModal" title="BootstrapVue"
                no-close-on-esc no-close-on-backdrop>
                <template #modal-header>
                    <h5 class="modal-title">Confirmation</h5>
                </template>
                <template #default>
                    <p>You have unsaved changes. Do you want to continue without saving?</p>
                </template>
                <template v-slot:modal-footer="{ ok, cancel }">
                    <b-button class="um-btn" @click="CancelModal">Continue without saving</b-button>
                    <b-button class="um-btn" @click="cancel()">Cancel</b-button>
                </template>
            </b-modal>
        </div>
        <NoticeModel ref="noticeModelRef" callbackOnClose></NoticeModel>
    </div>
</template>

<script>
import ApplicationSetting from "./ApplicationSetting";
import UserForm from "./shared/UserForm";
import Accounts from "./shared/Accounts";
import AccessibleApplications from "./shared/AccessibleApplications";
import ContactRole from "./shared/ContactRole";
import BasicInformation from "./shared/BasicInformation";
import AuditHistory from "./shared/AuditHistory";
import service from "../services/api.services";
import { Component as Loading } from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";
import { required, minLength } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import ErrorMessage from "./shared/ErrorMessage";
import { eventbus } from "../main";
import NoticeModel from "./shared/NoticeModel.vue";
import enviromentVariable from '../constants/enviromentVariable';

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    name: "EditUser",
    components: {
        UserForm,
        Accounts,
        AccessibleApplications,
        ContactRole,
        applications: [],
        ApplicationSetting,
        BasicInformation,
        AuditHistory,
        Loading,
        ErrorMessage,
        NoticeModel
    },
    data() {
        return {
            defaultapplication: "",
            form: this.userDetail,
            error: "",
            isLoading: false,
            fullPage: true,
            isUserCreationFailed: false,
            isDirty: false,
            isBusy: true,
            applicationSettingTitle: "",
            user_name: "",
            account: {},
            accountContactRoleList: [],
            applicationPermissionList: [],
            allPermissions: [],
            accessibleApplicationList: [],
            permissionrelatedData: [],
            applicationdetails: [],
            userAccounts: [],
            roles: "",
            showSetting: false,
            isEnabled: this.userDetail.enabled,
            isAccountPermissionAccess: false,
            isCustomerComunityEnabled: this.editingUserDetails.isCustomerComunityEnabled,
            isPartnerCommunity: this.editingUserDetails.isPartnerCommunity,
            showPermissions: this.editingUserDetails.arePermissionsEditable,
            tabIndex: 0,
            hasCaseFunctionalityAccess: false,
            isInvalidDateForNotice: enviromentVariable.isInvalidDateForNotice
        };
    },
    props: {
        editingUserDetails: {},
        userDetail: {},
        srcAccount: {}
    },
    watch: {
        account: function (newValue) {
            this.account = newValue;
        },
        editingUserDetails: function (newValue) {
            this.isCustomerComunityEnabled = newValue.isCustomerComunityEnabled;
            this.isPartnerCommunity = newValue.isPartnerCommunity;
            this.showPermissions = newValue.arePermissionsEditable;
        },
        userDetail: function (newValue) {
            this.form = newValue;
        }
    },
    computed: {
        applicationName: function () {
            if (this.applicationdetails.length > 0)
                return this.applicationdetails[0].applicationName;
            else return "";
        }
    },
    validations: {
        form: {
            firstName: { required, minLength: minLength(1) },
            lastName: { required, minLength: minLength(1) },
            userName: { required, minLength: minLength(1) },
            phone: { required }
        }
    },
    mounted() {
        var that = this;
        //window.addEventListener("beforeunload", function(event) {
        //  that.Windowhandler(event);
        //});
        eventbus.on("setApplicationSetting", function (title) {
            that.setApplicationSetting(title);
        });
        eventbus.on("UserStatusChanged", function (isEnabled) {
            that.userDetail.deactivated = !isEnabled
            that.userDetail.isEnable = isEnabled
            that.$emit("UserStatusChanged", isEnabled);
        });
        eventbus.on("setAssociatedAccount", function ([data, sfContactId, sfAccountId]) {
            that.setUserAccounts(data, sfContactId, sfAccountId);
        });
        eventbus.on("setAccountApplicationAccess", function (data) {
            that.setAccountApplicationAccess(data);
        });
        eventbus.on("setAccessibleApplication", function (data) {
            that.setAccessibleApplication(data);
        });
        eventbus.on("backToeditfromSetting", function (data) {
            that.backToeditfromSetting(data);
        });
        //console.log("Edit Mounted End");
    },
    methods: {
        //Windowhandler: function(event) {
        //  //if (this.isDirty) {
        //  //  event.returnValue = "Write something";
        //  //}
        //  },
        UserStatusChanged(value) {
            this.isEnabled = value;
            var updateStatus = true;
            this.userDetail.deactivated = !this.isEnabled;
            this.userDetail.isEnable = this.isEnabled;
            this.$refs.accessibleAccounts.userDetail.enabled = value;
            this.$emit("onUserUpdated", this.userDetail, updateStatus);
        },
        ChangedTab(Index) {
            this.tabIndex = Index
        },

        setEnableStatus(value) {
            this.$refs.bacisInfo.isEnabled = value;
            var updateStatus = true;
            this.isEnabled = value;
            this.userDetail.deactivated = !this.isEnabled;
            this.userDetail.isEnable = this.isEnabled;
            this.$emit("onUserUpdated", this.userDetail, updateStatus);
        },
        UserCommunityAccessChanged(value) {
            this.isCustomerComunityEnabled = value;
            this.showPermissions = true;
        },
        setUserAccounts: function (data, sfContactId, sfAccountId) {
            if (typeof sfContactId != "undefined") {
                if (this.userAccounts.length != data.length) {
                    eventbus.emit("onAccountRemovalUpdateUserList", [sfContactId, sfAccountId]);
                }
            }
            this.userAccounts = data;
        },
        backToeditfromSetting: function (data) {
            if (typeof data !== "undefined") {
                if (typeof data.roles !== "undefined" && data.roles != null) {
                    this.roles = data.roles.join(";");
                    this.account.roles = this.roles;
                }
                if (typeof data.permission !== "undefined" && data.permission != null) {
                    var updatedPermission = []
                    updatedPermission.push(data.permission.join(","))
                    this.account.permissions = updatedPermission
                }
            }
            this.showSetting = false;
        },
        setApplicationSetting: function (data) {
            this.isLoading = true;
            this.showSetting = true;
            this.applicationSettingTitle = data.title;
            this.accessibleApplicationList = [];
            this.accessibleApplicationList.push(data.title);
            this.GetAllPermissionForCustomerCommunity();
        },
        async GetAllPermissionForCustomerCommunity() {
            var that = this;
            that.allPermissions = [];
            await service.GetAllPermissions(that.account.sfAccountID).then(
                data => {
                    //console.log("Edit Dialog :: GetAllPermissionForCustomerCommunity :: GetAllPermissions",data);
                    if (data != null && data.length > 0) {
                        that.allPermissions = data;
                        that.GetAccountContactRolesByAccountId();
                    }
                },
                error => {
                    console.log(error);
                    that.allPermissions = [];
                }
            );
        },
        async GetAccountContactRolesByAccountId() {
            var that = this;
            that.accountContactRoleList = [];
            await service
                .GetAccountContactRolesByAccountId(that.account.sfAccountID)
                .then(
                    data => {
                        //console.log("Edit Dialog :: GetAllPermissionForCustomerCommunity :: GetAllPermissions :: GetAccountContactRolesByAccountId",data);
                        if (data != null && data.roleHelpText != null && data.roleHelpText.length > 0) {
                            data.roleHelpText.forEach(function (item) {
                                that.accountContactRoleList.push({
                                    roleName: item.role,
                                    roleAccess: false,
                                    roleHelpText: item.helpText
                                });
                            });

                            that.GetPermissionForCustomerCommunity();
                        }
                    },
                    error => {
                        console.log(error);
                        that.accountContactRoleList = [];
                    }
                );
        },
        GetPermissionForCustomerCommunity() {
            var that = this;
            that.hasCaseFunctionalityAccess = false;
            if (that.editingUserDetails.accountsApplicationsAndRolesDetail != null && that.editingUserDetails.accountsApplicationsAndRolesDetail.length > 0) {
                var data = that.editingUserDetails.accountsApplicationsAndRolesDetail.find(x => x.sfAccountID == that.account.sfAccountID);
                if (data != null) {
                    //Set Permissions access                      
                    if (data.permissions != null && data.permissions.length > 0) {
                        that.applicationPermissionList = data.permissions[0].split(",");
                        that.allPermissions.forEach(function (permissionGroup) {
                            if (permissionGroup.groupName == 'Cases Functionality') {
                                that.hasCaseFunctionalityAccess = true;
                            }

                            permissionGroup.roles.forEach(function (role) {
                                role.isAccess = false;
                                if (that.applicationPermissionList.indexOf(role.label) != -1)
                                    role.isAccess = true;
                                else
                                    role.isAccess = false;
                            });

                            //Set Permisssion group access
                            permissionGroup.isAccess = true;
                            permissionGroup.roles.find(function (item) {
                                if (item.isAccess == false)
                                    permissionGroup.isAccess = false;
                            });
                        });

                        //Set All Permissions
                        var checkPermission = [];
                        checkPermission = that.allPermissions.filter(x => {
                            return x.isAccess == false;
                        });
                        if (checkPermission.length == 0)
                            that.isAccountPermissionAccess = true;
                        else
                            that.isAccountPermissionAccess = false;

                    }
                    else {
                        that.allPermissions.forEach(function (permissionGroup) {
                            if (permissionGroup.groupName == 'Cases Functionality') {
                                that.hasCaseFunctionalityAccess = true;
                            }
                            permissionGroup.roles.forEach(function (role) {
                                role.isAccess = false;
                            });
                            permissionGroup.isAccess == false;
                        });
                        that.isAccountPermissionAccess = false;
                    }
                    //Set Roles
                    if (data.roles != null && data.roles != "") {
                        var roleList = data.roles.split(";");
                        that.accountContactRoleList.forEach(function (item) {
                            if (roleList.indexOf(item.roleName) != -1)
                                item.roleAccess = true;
                            else
                                item.roleAccess = false;
                        });
                        that.roles = that.accountContactRoleList
                            .filter(x => x.roleAccess == true)
                            .map(function (role) {
                                return role.roleName;
                            })
                            .join(";");
                    }
                }
            }
            that.isLoading = false;
            if (that.showSetting)
                that.$bvModal.show("applicationsetting")

            if (that.hasCaseFunctionalityAccess && that.showPermissions) {
                let isValidNotice = false;
                isValidNotice = this.checkIsValidNotice();

                if (isValidNotice) {
                    if (that.$refs.noticeModelRef && that.$refs.noticeModelRef.$refs["noticeModel"])
                        that.$refs.noticeModelRef.$refs["noticeModel"].show();
                    else
                        that.$bvModal.show("noticemodel");
                }
            }

        },
        setAccessibleApplication: function (data) {
            this.applicationdetails = data;
            this.applicationSettingTitle = this.applicationdetails[0].applicationName;
            this.accessibleApplicationList = [];
            this.accessibleApplicationList.push(this.applicationSettingTitle);
            // console.log("Edit Dialog :: setAccessibleApplication");
            // this.GetAllPermissionForCustomerCommunity();
        },
        setAccountApplicationAccess: function (data) {
            //console.log("setAccountApplicationAccess :: after account loaded", data);
            this.roles = "";
            this.accountContactRoleList = [];
            this.applicationdetails = [];
            this.account = data;
            this.user_name = this.userDetail.userName; // From Account Update
        },
        formIsDirty: function (isChange) {
            this.isDirty = isChange;
            this.$store.dispatch("setIsPageDirty", isChange);
        },
        setUserDetails: function (data) {
            this.form = data;
        },
        CancelModal: function () {
            this.showSetting = false;
            var updateStatus = false;
            this.$refs["editUserModel"].hide();
            this.$refs["CancelPromptModal"].hide();
            this.isDirty = false;
            this.$store.dispatch("setIsPageDirty", false);
            this.$emit("onUserUpdated", this.userDetail, updateStatus);
        },
        cancelChanges: function () {
            var updateStatus = false;
            if (this.isDirty) {
                this.$refs["CancelPromptModal"].show();
            } else {
                this.showSetting = false;
                this.roles = "";
                this.accountContactRoleList = [];
                this.applicationdetails = [];
                this.account = {};
                this.$emit("onUserUpdated", this.userDetail, updateStatus);
                this.$refs["editUserModel"].hide();
            }
            this.tabIndex = 0;
        },
        SaveUser: function () {
            this.getUserInfovalue();
            if (this.v$.form.$error) {
                this.tabIndex = 0;
            }
            this.updateUserInfo();
        },
        async updateUserInfo() {
            this.v$.form.$touch();
            this.prepareContactBasicInfo();
            this.prepareUserDetail();
            var patchContactModel = {
                "contactDetail": this.userDetail,
                "patchContact": this.patchObjectArr
            }
            if (this.v$.form.$error) {
                return false;
            } else {
                this.isLoading = true;
                var that = this;
                await service
                    //.UpdateUser(this.userDetail)
                    .UpdateContactBasicInfo(patchContactModel)
                    .then(response => {
                        that.isDirty = false;
                        that.$store.dispatch("setIsPageDirty", false);
                        if (response.data == "") {
                            that.isLoading = false;
                            var updateStatus = false;
                            that.$emit("onUserUpdated", that.userDetail, updateStatus);
                            that.tabIndex = 0;
                            that.$refs["editUserModel"].hide();
                        } else {
                            that.isLoading = false;
                            that.error = response.data;
                            if (that.$refs.errorMessageRef && that.$refs.errorMessageRef.$refs["ErrorMessageModel"])
                                that.$refs.errorMessageRef.$refs["ErrorMessageModel"].show();
                            else
                                that.$bvModal.show("errormessage");
                        }
                    })
                    .catch(error => {
                        this.isDirty = false;
                        that.isLoading = false;
                        that.$store.dispatch("setIsPageDirty", false);
                        console.log("api error:" + error);
                    });
            }
        },
        prepareUserDetail() {
            var that = this;
            that.userDetail.firstName = (that.form.firstName);
            that.userDetail.middleInitial = (that.form.middleInitial);
            that.userDetail.lastName = (that.form.lastName);
            that.userDetail.title = (that.form.title);
            that.userDetail.phone = (that.form.phone);
            that.userDetail.streetAddress = (that.form.streetAddress);
            that.userDetail.city = (that.form.city);
            that.userDetail.state = (that.form.state);
            that.userDetail.postalCode = (that.form.postalCode);
            that.userDetail.country = (that.form.country);
            that.userDetail.languagePreference = (that.form.languagePreference);
            var primaryAcc = this.userAccounts.find(x => x.direct == true);
            if (typeof primaryAcc != "undefined") {
                that.userDetail.accountId = primaryAcc.sfAccountID
                that.userDetail.sfAccountId = primaryAcc.sfAccountID
            }
            else
                that.userDetail.accountId = that.account.sfAccountID

            if (that.permissionrelatedData.SelectedUserPermissions != "")
                that.userDetail.permission =
                    that.permissionrelatedData.SelectedUserPermissions;
            if (that.permissionrelatedData.SelectedContactRoles != "")
                that.userDetail.roles = that.permissionrelatedData.SelectedContactRoles;
            if (
                that.applicationdetails.length > 0 &&
                that.permissionrelatedData.application != ""
            ) {
                //TODO :: Need to change in case of multiple application present in list
                var app = that.applicationdetails.find(function (item) {
                    if (item.applicationName == that.permissionrelatedData.application) {
                        return item;
                    }
                });
                var applist = [];
                applist.push(app);
                that.userDetail.ApplicationDetails = applist;
            }
        },
        getUserInfovalue: function () {
            this.$refs.userForm.getvalue();
        },
        prepareContactBasicInfo() {
            var that = this;
            that.patchObjectArr = []
            if (that.userDetail.firstName != that.form.firstName)
                this.patchObjectArr.push({ "value": (that.form.firstName), "path": "FirstName" })
            if (that.userDetail.middleInitial != that.form.middleInitial)
                this.patchObjectArr.push({ "value": (that.form.middleInitial), "path": "MiddleInitial" })
            if (that.userDetail.lastName != that.form.lastName)
                this.patchObjectArr.push({ "value": (that.form.lastName), "path": "LastName" })
            if (that.userDetail.title != that.form.title)
                this.patchObjectArr.push({ "value": (that.form.title), "path": "Title" })
            if (that.userDetail.phone != that.form.phone)
                this.patchObjectArr.push({ "value": (that.form.phone), "path": "Phone" })
            if (that.userDetail.streetAddress != that.form.streetAddress)
                this.patchObjectArr.push({ "value": (that.form.streetAddress), "path": "StreetAddress" })
            if (that.userDetail.city != that.form.city)
                this.patchObjectArr.push({ "value": (that.form.city), "path": "City" })
            if (that.userDetail.state != that.form.state)
                this.patchObjectArr.push({ "value": (that.form.state), "path": "State" })
            if (that.userDetail.postalCode != that.form.postalCode)
                this.patchObjectArr.push({ "value": (that.form.postalCode), "path": "PostalCode" })
            if (that.userDetail.country != that.form.country)
                this.patchObjectArr.push({ "value": (that.form.country), "path": "Country" })
            if (that.userDetail.languagePreference != that.form.languagePreference)
                this.patchObjectArr.push({ "value": (that.form.languagePreference), "path": "LanguagePreference" })
        },
        checkIsValidNotice() {
            var loggedinUsername = this.$store.getters.username;
            var hasDoNotShowAgainCheckboxchecked = document.cookie.includes('DoNotShowAgainFor' + loggedinUsername + 'Confirmed');

            return (this.isInvalidDateForNotice == 'False') && !hasDoNotShowAgainCheckboxchecked;
        }
    }
};
</script>